import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import apiCall from "./../../API/API";
import PhoneInput from "react-phone-number-input";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { CloudFog } from "lucide-react";

const EditProfileSection = ({ user, onCancel }) => {
  const navigate = useNavigate();
  const [file, setFile] = useState(user?.profile_pic || "");
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState(user?.mobile || "");
  const [userid, setUserid] = useState(user?.uid || "");
  const [username, setUsername] = useState(user?.username || "");
  const [address, setAddress] = useState(user?.wallet_address || "");
  const [success, setSuccess] = useState("null");
  function delay(delayInms) {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
  }
  const [errors, setErrors] = useState({});
  // console.log("user", user);

  const validateForm = () => {
    let newErrors = {};
    if (address && !/^0x[a-fA-F0-9]{40}$/.test(address.trim())) {
      newErrors.address = "Invalid wallet address format";
    }
    if (!name?.trim()) {
      newErrors.name = "Name is required";
    }
    if (!email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is not valid";
    }
    if (!phone?.trim()) {
      newErrors.phone = "Mobile number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const { data, error } = await apiCall(
        "POST",
        `/user-profile-update?uid=${userid}`,
        {
          wallet_address: address?.trim() || undefined,
          name: name?.trim(),
          email: email?.trim(),
          mobile: phone?.trim() || phone,
        },
        true
      );
      if (data) {
        await delay(500);
        navigate("/dashboard/all_users");
      } else {
        toast.error(error?.message || "Failed to update profile");
      }
    }
  };

  return (
    <>
      <React.Fragment>
        <section className="formItems">
          {/* <div className="uploadImage">
            <img src={file} alt="logo.png" />
            <div className="chooseFile">
              <label>
                <span>Upload Profile</span>
                <input
                  type="file"
                  onChange={(e) => (
                    setFile(URL.createObjectURL(e.target.files[0])),
                    console.log({ file })
                  )}
                />
              </label>
            </div>
          </div> */}
          <div className="form">
            <Row>
              <Col lg="2"></Col>
              <Col lg="8">
                <form onSubmit={handleSubmit} className="registerForm">
                  <div>
                    <label>User Id</label>
                    <input type="number" value={userid} readOnly />
                  </div>
                  <div>
                    <label>Username</label>
                    <input type="text" value={username} readOnly />
                  </div>
                  <div>
                    <label>Full Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter full name"
                    />
                    {errors.name && (
                      <div className="formError">{errors.name}</div>
                    )}
                  </div>
                  <div>
                    <label>Email Address</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email address"
                    />
                    {errors.email && (
                      <div className="formError">{errors.email}</div>
                    )}
                  </div>
                  <div>
                    <label>Contact Number</label>
                    <PhoneInput
                      id="phoneInput"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={phone}
                      onChange={(value) => setPhone(value)}
                      placeholder="Enter mobile number"
                    />
                    {errors.phone && (
                      <div className="formError">{errors.phone}</div>
                    )}
                  </div>
                  <div>
                    <label>Wallet Address</label>
                    <input
                      type="text"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Enter wallet address (BEP20)"
                    />
                    {errors.address && (
                      <div className="formError">{errors.address}</div>
                    )}
                  </div>
                  <button onClick={handleSubmit} className="save">
                    Save
                  </button>
                  <a onClick={onCancel} className="cancel">
                    Cancel
                  </a>
                </form>
              </Col>
            </Row>
          </div>
        </section>
        {/* <ToastContainer className="toast-container" /> */}
      </React.Fragment>
    </>
  );
};

export default EditProfileSection;
